import React from 'react';
import ReactDOM from 'react-dom';
import Modal from './modal_poster';

const show_poster = props => {
    // console.log(props);
    let component = null;
    let div = null;

    if (document.querySelector('#modal_root')) {
        div = document.querySelector('#modal_root');
    } else {
        div = document.createElement('div');
        document.querySelector('#root').appendChild(div);

        div.id = 'modal_root';
        div.classList.add('modal_root');
    }

    const modal = document.createElement('div');

    modal.id = `modal_${new Date().getTime()}`;
    div.appendChild(modal);

    const onClose = () => {
        ReactDOM.unmountComponentAtNode(modal);
        div.removeChild(modal);
        if (typeof props.onClose === 'function') {
            props.onClose();
        }
    };

    ReactDOM.render(
        /* eslint-disable */
        <Modal {...props} onClose={onClose} ref={c => (component = c)} isOpen>
            {props.content}
        </Modal> /* eslint-enable */,
        modal,
    );
};

const Poster = {
    show: props =>
        show_poster({
            ...props,
        }),
};

export { Poster };
